// extracted by mini-css-extract-plugin
export default {"iconContainer":"IconWithFlowyBackground_iconContainer__4VGvL","icon":"IconWithFlowyBackground_icon__mLeEG"};